<template>
  <div id="locationForm" class="form">

    <v-card-title>
      {{ id ? "Edit " : "Add " }}
      <v-spacer />
      <v-btn icon @click="goBack"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>

    <v-card-text>
      <v-form ref="form">
        <v-text-field v-model="location.name" label="Location Name aa" :rules="requiredRules" />
        <v-row>
          <v-col cols="12" lg="6">
            <v-text-field v-model="location.codeName" label="Location Code" hint="Abbreviation for company name" />
          </v-col>
          <v-col cols="12" lg="6">
            <v-text-field type="number" v-model="location.code" label="Location Number" hint="Number for the location" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" lg="6">
            <v-text-field v-model="location.lat" label="Geo Location Latitude" />
          </v-col>
          <v-col cols="12" lg="6">
            <v-text-field v-model="location.lng" label="Geo Location Longitude" />
          </v-col>
        </v-row>
        <v-text-field v-model="location.email" label="Email" :rules="emailRules" />
        <v-text-field v-mask="'+1(###) ###-####'" v-model="location.phoneNumber" label="Phone Number" />
        <v-text-field v-model="location.ip" label="Static IP" />
        <v-textarea :auto-grow="true" rows="1" v-model="location.address" label="Address" />
        <v-textarea :auto-grow="true" rows="1" v-model="location.receiptHeader" label="Receipt Header" />
        <v-textarea :auto-grow="true" rows="1" v-model="location.invoiceHeader" label="Invoice Header" />
      </v-form>
    </v-card-text>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";

export default {
  props: {
    location: {
      type: Object,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    isModal: {
      type: Boolean,
      required: false,
    },
  },
  directives: { mask },
  data: () => ({
    requiredRules: [(v) => !!v || "This field is required"],
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
  }),
};
</script>

<style></style>